import { LISTA_SISTEMAS } from './listaSistemas';

export const LISTA_PERMISSOES = {
  FIN_ADMIN: 'FIN_ADMIN',
  FIN_USUARIO: 'FIN_USUARIO',
  FIN_VENDEDOR_EXTERNO: 'FIN_VENDEDOR_EXTERNO',
  MASTER: 'MASTER',
  SDE_ADMIN: 'SDE_ADMIN',
  SDE_MEDICO: 'SDE_MEDICO',
  SDE_SECRETARIO: 'SDE_SECRETARIO',
  SDE_FARMACEUTICO: 'SDE_FARMACEUTICO',
  SDE_ALMOXARIFE: 'SDE_ALMOXARIFE',
  SDE_ENFERMEIRO: 'SDE_ENFERMEIRO',
  SUP_ADMIN: 'SUP_ADMIN',
  SUP_USUARIO: 'SUP_USUARIO',
};

const nmSistema = (cdsistema) => LISTA_SISTEMAS.find(s => s.cdsistema === cdsistema)?.nmsistema;

// Descrição e agrupamento por sistema (cdsistema/nmsistema de listaSistemas.js) de
// cada permissão de LISTA_PERMISSOES. Usado para exibir a seleção de permissões
// agrupada nas telas de usuário.
export const PERMISSOES_POR_SISTEMA = [
  {
    cdsistema: 1,
    nmsistema: nmSistema(1),
    permissoes: [
      { codigo: LISTA_PERMISSOES.SDE_ADMIN, descricao: 'Administrador' },
      { codigo: LISTA_PERMISSOES.SDE_MEDICO, descricao: 'Médico' },
      { codigo: LISTA_PERMISSOES.SDE_SECRETARIO, descricao: 'Secretário' },
      { codigo: LISTA_PERMISSOES.SDE_FARMACEUTICO, descricao: 'Farmacêutico' },
      { codigo: LISTA_PERMISSOES.SDE_ALMOXARIFE, descricao: 'Almoxarife' },
      { codigo: LISTA_PERMISSOES.SDE_ENFERMEIRO, descricao: 'Enfermeiro' },
    ],
  },
  {
    cdsistema: 2,
    nmsistema: nmSistema(2),
    permissoes: [
      { codigo: LISTA_PERMISSOES.FIN_ADMIN, descricao: 'Administrador' },
      { codigo: LISTA_PERMISSOES.FIN_USUARIO, descricao: 'Usuário' },
      { codigo: LISTA_PERMISSOES.FIN_VENDEDOR_EXTERNO, descricao: 'Vendedor Externo' },
    ],
  },
  {
    cdsistema: 4,
    nmsistema: nmSistema(4),
    permissoes: [
      { codigo: LISTA_PERMISSOES.SUP_ADMIN, descricao: 'Administrador' },
      { codigo: LISTA_PERMISSOES.SUP_USUARIO, descricao: 'Usuário' },
    ],
  },
  {
    cdsistema: null,
    nmsistema: 'Geral',
    permissoes: [
      { codigo: LISTA_PERMISSOES.MASTER, descricao: 'Master (acesso total a todos os sistemas)' },
    ],
  },
];
